import { combineReducers } from "redux";
import * as Form from 'react-redux-form';
import * as authenticationDomain from "user/authentication/Authentication";
export const authenticationFormsReducer = combineReducers({
    //-- Login
    login: Form.modelReducer('authenticationForms.login', authenticationDomain.initialLogin),
    loginForm: Form.formReducer('authenticationForms.login', authenticationDomain.initialLogin),
    //-- Request Verify
    requestVerify: Form.modelReducer('authenticationForms.requestVerify', authenticationDomain.initialRequestVerify),
    requestVerifyForm: Form.formReducer('authenticationForms.requestVerify', authenticationDomain.initialRequestVerify),
    //-- Verify
    verify: Form.modelReducer('authenticationForms.verify', authenticationDomain.initialVerify),
    verifyForm: Form.formReducer('authenticationForms.verify', authenticationDomain.initialVerify),
    //-- Forgot Password
    forgotPassword: Form.modelReducer('authenticationForms.forgotPassword', authenticationDomain.initialForgotPassword),
    forgotPasswordForm: Form.formReducer('authenticationForms.forgotPassword', authenticationDomain.initialForgotPassword),
    //-- Reset Password
    resetPassword: Form.modelReducer('authenticationForms.resetPassword', authenticationDomain.initialResetPassword),
    resetPasswordForm: Form.formReducer('authenticationForms.resetPassword', authenticationDomain.initialResetPassword)
});
//-- Populate path names for Forms
export function configureFormStrings(authenticationForms) {
    try {
        //-- Login
        const pathLogin = authenticationForms.loginForm.$form.model;
        authenticationDomain.pathsLogin.modelPath = pathLogin;
        Object.keys(authenticationForms.login).map((key) => {
            authenticationDomain.pathsLogin[key] = `${pathLogin}.${key}`;
        });
        //-- Request Verify
        const pathRequestVerify = authenticationForms.requestVerifyForm.$form.model;
        authenticationDomain.pathsRequestVerify.modelPath = pathRequestVerify;
        Object.keys(authenticationForms.requestVerify).map((key) => {
            authenticationDomain.pathsRequestVerify[key] = `${pathRequestVerify}.${key}`;
        });
        //-- Verify
        const pathVerify = authenticationForms.verifyForm.$form.model;
        authenticationDomain.pathsVerify.modelPath = pathVerify;
        Object.keys(authenticationForms.verify).map((key) => {
            authenticationDomain.pathsVerify[key] = `${pathVerify}.${key}`;
        });
        //-- Forgot Password
        const pathForgotPassword = authenticationForms.forgotPasswordForm.$form.model;
        authenticationDomain.pathsForgotPassword.modelPath = pathForgotPassword;
        Object.keys(authenticationForms.forgotPassword).map((key) => {
            authenticationDomain.pathsForgotPassword[key] = `${pathForgotPassword}.${key}`;
        });
        //-- Reset Password
        const pathResetPassword = authenticationForms.resetPasswordForm.$form.model;
        authenticationDomain.pathsResetPassword.modelPath = pathResetPassword;
        Object.keys(authenticationForms.resetPassword).map((key) => {
            authenticationDomain.pathsResetPassword[key] = `${pathResetPassword}.${key}`;
        });
    }
    catch (err) {
        console.log("Error mapping Form Path names. Please fix.", err);
    }
}
